<style scoped>  

  @media only screen and (max-width: 360px) {
    .search-input {
      max-width: 80% !important;
    }
  }

  @media only screen and (min-width: 361px) {
    .search-input {
      max-width: 85% !important;
    }
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div v-if="$isSimavet()" class="ten wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$refs.formModal.create()">
          <i class="plus icon"></i> Nova Ficha
        </button>
      </div>
      <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic segment no-padding no-margin" :class="{ 'right aligned': $isSimavet() }">
          <div class="ui form">
            <div class="field">
              <search-input id="animal-registrations-search-input" ref="searchInput" class="search-input" @onSearch="search" />
              <button class="ui icon button m-l-10" @click="$refs.filterModal.show()">
                <i class="filter icon" :class="{ red: !!$store.state.pages.filters.animalRegistrations }"></i>
              </button>
            </div>
          </div>                        
        </div> 
      </div>      
    </div>

    <data-table id="animal-registrations-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="onShowRegistration" />

    <filter-modal ref="filterModal" @onApply="filter" @onRemove="clearFilter" />

    <form-modal ref="formModal" @onSave="refresh" @onRemove="refresh" />

  </div>

</template>

<script>
  
  import AnimalRegistrationService from "@/services/animal-registration-service"
  import FilterModal from "./filter"
  import FormModal from "./form-modal"
  import gridPage from "@/mixins/grid-page"

  export default {    

    name: "AnimalRegistrationsPage",

    mixins: [gridPage],

    data() {
      return {     
        title: "Fichas Cadastrais",   
        service: new AnimalRegistrationService(),
        attributes: ["id", "registrationId", "customerId", "animalId", "ownerId"],
        fields: [          
          { prop: "customer.shortName", label: "Clínica" },
          { prop: "animal.name", label: "Animal", render: this.renderAnimal },
          { prop: "owner.name", label: "Tutor" },
          { prop: "registrationId", label: "Número da Ficha" },
        ],
      }
    },

    components: {
      FilterModal,
      FormModal,
    },

    methods: {

      onShowRegistration(data) {
        this.$router.push(`/entries/animal-registrations/${data.row.id}`)
      },

      renderAnimal(registration) {

        if (!registration || !registration.animal)
          return ""

        const animal = registration.animal
        const race = animal.race
        const species = race.species        
        const raceLabel = `<div class="ui small label">${race.name}<div class="detail">Espécie ${species.name}</div></div>`     
        const deadIcon = animal.dead ? '<i class="cross grey icon m-l-5"></i>' : ""   
        
        let sexIcon = animal.sex == "male" ? "mars blue icon" : "venus pink icon"

        if (animal.sex == "undefined")
          sexIcon = "question circle grey icon"

        return `<i class="${sexIcon}"></i> ${animal.name} ${raceLabel} ${deadIcon}`
      },      
    },
  }

</script>
